import { render, staticRenderFns } from "./create-income-detail.vue?vue&type=template&id=1008836a&scoped=true"
import script from "./create-income-detail.vue?vue&type=script&lang=ts"
export * from "./create-income-detail.vue?vue&type=script&lang=ts"
import style0 from "./create-income-detail.vue?vue&type=style&index=0&id=1008836a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008836a",
  null
  
)

export default component.exports